"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwap = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ImageCard = require("./ImageCard");
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _ImageErrorFallback = require("./ImageErrorFallback");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SliderSwap = exports.SliderSwap = function SliderSwap(_ref) {
  var _sliderContainerRef$c, _iconNextRef$current, _iconPrevRef$current;
  var _ref$files = _ref.files,
    files = _ref$files === void 0 ? [] : _ref$files,
    toggleFullscreen = _ref.toggleFullscreen,
    setFullscreen = _ref.setFullscreen,
    otherButton = _ref.otherButton,
    _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
    handleImageClickToFullscreen = _ref.handleImageClickToFullscreen,
    fileType = _ref.fileType,
    setIndex = _ref.setIndex,
    index = _ref.index,
    tabSelected = _ref.tabSelected,
    _ref$setURLOpenFullsc = _ref.setURLOpenFullscreen,
    setURLOpenFullscreen = _ref$setURLOpenFullsc === void 0 ? function () {} : _ref$setURLOpenFullsc;
  var sliderContainerRef = (0, _react.useRef)(null);
  var sliderRef = (0, _react.useRef)(null);
  var iconNextRef = (0, _react.useRef)(null);
  var iconPrevRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    startPos = _useState4[0],
    setStartPos = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    startPosY = _useState6[0],
    setStartPosY = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    currentTranslate = _useState8[0],
    setCurrentTranslate = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    prevTranslate = _useState10[0],
    setPrevTranslate = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    startTime = _useState12[0],
    setStartTime = _useState12[1];
  var _useState13 = (0, _react.useState)(true),
    _useState14 = _slicedToArray(_useState13, 2),
    isClick = _useState14[0],
    setIsClick = _useState14[1];
  var sliderContainerWidth = (_sliderContainerRef$c = sliderContainerRef.current) === null || _sliderContainerRef$c === void 0 ? void 0 : _sliderContainerRef$c.offsetWidth;
  var iconNextPosition = (_iconNextRef$current = iconNextRef.current) === null || _iconNextRef$current === void 0 ? void 0 : _iconNextRef$current.getBoundingClientRect();
  var iconPrevPosition = (_iconPrevRef$current = iconPrevRef.current) === null || _iconPrevRef$current === void 0 ? void 0 : _iconPrevRef$current.getBoundingClientRect();
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    translateX = _useState16[0],
    setTranslateX = _useState16[1];
  var _useState17 = (0, _react.useState)(0),
    _useState18 = _slicedToArray(_useState17, 2),
    visibledIndex = _useState18[0],
    setVisibledIndex = _useState18[1];
  var _useState19 = (0, _react.useState)({}),
    _useState20 = _slicedToArray(_useState19, 2),
    imgErrors = _useState20[0],
    setImgErrors = _useState20[1];
  var debounce = function debounce(func, wait) {
    var timeout;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return func.apply(void 0, args);
      }, wait);
    };
  };
  var touchStart = function touchStart(event) {
    var position = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
    var positionY = event.type === 'mousedown' ? event.clientY : event.touches[0].clientY;
    setStartPos(position);
    setStartPosY(positionY);
    setIsDragging(true);
    setPrevTranslate(translateX);
    setStartTime(Date.now());
    setIsClick(true);
  };
  var touchMove = function touchMove(event) {
    if (isDragging) {
      var currentPosition = event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
      var translate = currentPosition - startPos + prevTranslate;
      setCurrentTranslate(translate);
      handleTraslate(translate);
      if (Math.abs(currentPosition - startPos) > 5) {
        setIsClick(false);
      }
    }
  };
  var debouncedTouchEnd = debounce(function () {
    if (isDragging) {
      setIsDragging(false);
      var movedBy = currentTranslate - prevTranslate;
      var elapsedTime = Date.now() - startTime;
      if (isClick && elapsedTime < 300) {
        if (files.length === 0) return;
        if (startPos > iconNextPosition.x - 10 && startPosY < iconNextPosition.y + 40 && startPosY > iconNextPosition.y - 10) {
          return debouncedNextSlide();
        }
        if (startPos < iconPrevPosition.x + 40 && startPosY < iconPrevPosition.y + 40 && startPosY > iconPrevPosition.y - 10) {
          return debouncedPrevSlide();
        }
        if (!fullScreen) setFullscreen(true);
        return;
      }
      if (movedBy < -10 && translateX > -(sliderContainerWidth * (files.length - 1))) {
        nextSlide();
      } else if (movedBy > 50 && translateX < 0) {
        prevSlide();
      } else {
        handleTraslate(prevTranslate);
      }
      resetPosition();
    }
  }, 50);
  var touchEnd = function touchEnd() {
    debouncedTouchEnd();
  };
  var nextSlide = function nextSlide() {
    var newTranslateX = Math.max(translateX - sliderContainerWidth, -sliderContainerWidth * (files.length - 1));
    setTranslateX(newTranslateX);
    handleTraslate(newTranslateX);
  };
  var prevSlide = function prevSlide() {
    var newTranslateX = Math.min(translateX + sliderContainerWidth, 0);
    setTranslateX(newTranslateX);
    handleTraslate(newTranslateX);
  };
  var debouncedNextSlide = debounce(nextSlide, 170);
  var debouncedPrevSlide = debounce(prevSlide, 170);
  var resetPosition = function resetPosition() {
    setCurrentTranslate(0);
  };
  (0, _react.useEffect)(function () {
    var sliderContainer = sliderContainerRef.current;
    sliderContainer.addEventListener('mousedown', touchStart);
    sliderContainer.addEventListener('mouseup', touchEnd);
    sliderContainer.addEventListener('mousemove', touchMove);
    sliderContainer.addEventListener('touchstart', touchStart, {
      passive: true
    });
    sliderContainer.addEventListener('touchend', touchEnd);
    sliderContainer.addEventListener('touchmove', touchMove, {
      passive: true
    });
    return function () {
      sliderContainer.removeEventListener('mousedown', touchStart, {
        passive: true
      });
      sliderContainer.removeEventListener('mouseup', touchEnd);
      sliderContainer.removeEventListener('mousemove', touchMove);
      sliderContainer.removeEventListener('touchstart', touchStart);
      sliderContainer.removeEventListener('touchend', touchEnd);
      sliderContainer.removeEventListener('touchmove', touchMove, {
        passive: true
      });
    };
  }, [isDragging, startPos, currentTranslate, prevTranslate, translateX, files.length, startTime, isClick]);
  (0, _react.useEffect)(function () {
    if (fullScreen) return;
    setVisibledIndex(Math.round(Math.abs(translateX / sliderContainerWidth)));
  }, [translateX, fullScreen]);
  (0, _react.useEffect)(function () {
    setURLOpenFullscreen(files[visibledIndex || 0]);
    if (handleImageClickToFullscreen) {
      handleImageClickToFullscreen(files[visibledIndex]);
    }
  }, [visibledIndex]);
  (0, _react.useEffect)(function () {
    if (fullScreen && sliderContainerWidth) {
      setIndex(-translateX / sliderContainerWidth);
    }
  }, [translateX, tabSelected, fullScreen]);
  (0, _react.useEffect)(function () {
    if (!sliderContainerWidth) return;
    if (fullScreen) {
      handleTraslate(-sliderContainerWidth * index);
      setTranslateX(-sliderContainerWidth * index);
    }
  }, [fullScreen, tabSelected, sliderContainerWidth]);
  (0, _react.useEffect)(function () {
    if (fullScreen) handleTraslate(-sliderContainerWidth * index);
  }, [index]);
  var handleImgError = function handleImgError(url) {
    setImgErrors(function (prevErrors) {
      return _objectSpread(_objectSpread({}, prevErrors), {}, _defineProperty({}, url, true));
    });
  };
  var handleTraslate = function handleTraslate(traslation) {
    var _sliderRef$current;
    if (!((_sliderRef$current = sliderRef.current) !== null && _sliderRef$current !== void 0 && _sliderRef$current.style)) return;
    return sliderRef.current.style.transform = "translateX(".concat(traslation, "px)");
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    ref: sliderContainerRef,
    __css: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    ref: sliderRef,
    __css: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      transition: 'transform .2s ease'
    },
    className: "sliderContainer"
  }, !fullScreen && files.length > 0 && files.map(function (img, index) {
    return /*#__PURE__*/_react["default"].createElement(_ImageCard.ImageCard, {
      key: index,
      className: "firstTabImg",
      position: 'relative',
      height: '100%',
      minWidth: '100%',
      url: img
    });
  }), !fullScreen && files.length === 0 && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    onClick: function onClick() {
      return toggleFullscreen();
    },
    __css: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      backgroundColor: _theme["default"].colors.neutralGray7,
      borderRadius: '12px',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    width: "100%",
    height: "100%",
    icon: "icon-propiedades",
    fontSize: "34px",
    color: _theme["default"].colors.neutralGray4
  })), fullScreen && (fileType === 'fotos' || fileType === 'planos') && files.map(function (img, index) {
    return /*#__PURE__*/_react["default"].createElement(_box.Box, {
      key: index,
      __css: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100%',
        maxWidth: '100%',
        height: '100%',
        borderRadius: '12px',
        cursor: 'pointer'
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onDragStart: function onDragStart(e) {
        return e.preventDefault();
      }
    }, imgErrors[img] ? /*#__PURE__*/_react["default"].createElement(_ImageErrorFallback.ImageErrorFallback, {
      fullscreen: true
    }) : /*#__PURE__*/_react["default"].createElement("img", {
      className: "imgFullScreenSlide",
      style: {
        pointerEvents: 'none'
      },
      src: img,
      alt: fileType,
      onError: function onError() {
        return handleImgError(img);
      }
    }));
  }), fullScreen && (fileType === 'videos' || fileType === 'video360') && files.map(function (video, index) {
    return /*#__PURE__*/_react["default"].createElement(_box.Box, {
      key: index,
      __css: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        height: "".concat(sliderContainerWidth * 0.7, "px"),
        borderRadius: '12px',
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react["default"].createElement("iframe", {
      className: "videoFullScreenSlide",
      src: video,
      title: fileType,
      allowFullScreen: true
    }));
  })), (!fullScreen && files.length > 0 || fullScreen) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      left: fullScreen ? '-5px' : '16px',
      width: sliderContainerWidth < 700 ? '30px' : '40px',
      height: sliderContainerWidth < 700 ? '30px' : '40px'
    },
    ref: iconPrevRef,
    className: "nextPrevIconContainer ".concat(fullScreen ? 'fullScreen' : '')
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    className: "swapSliderIconPrev ".concat(fullScreen ? 'fullScreen' : ''),
    icon: "icon-atras",
    style: {
      fontSize: sliderContainerWidth < 700 && !fullScreen ? '12px' : '24px'
    }
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      right: fullScreen ? '-5px' : '16px',
      width: sliderContainerWidth < 700 ? '30px' : '40px',
      height: sliderContainerWidth < 700 ? '30px' : '40px'
    },
    ref: iconNextRef,
    className: "nextPrevIconContainer ".concat(fullScreen ? 'fullScreen' : '')
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    className: "swapSliderIconNext ".concat(fullScreen ? 'fullScreen' : ''),
    style: {
      transform: 'rotate(180deg)',
      fontSize: sliderContainerWidth < 700 && !fullScreen ? '12px' : '24px'
    },
    icon: "icon-atras"
  }))), !fullScreen && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "otherButtonSwap"
  }, otherButton));
};